var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import serialize from 'serialize-javascript';
import getInitialData from '../../services/server/getInitialData';
import { FooterContext } from './FooterContext';
import { getKillSwitchCMS } from '../../utils/helper';
export default function FooterProvider(props) {
    function getAppData() {
        if (typeof window !== 'undefined') {
            //@ts-ignore
            var data_1 = window.initialFooterData;
            //@ts-ignore
            delete window.initialFooterData;
            return data_1;
        }
    }
    function getStoreConfig() {
        if (typeof window !== 'undefined') {
            //@ts-ignore
            var storeConf_1 = window.storeConf;
            return storeConf_1;
        }
    }
    var _a = __read(React.useState(false), 2), loading = _a[0], setLoading = _a[1];
    var children = props.children;
    var _b = __read(React.useState(getAppData() || props.data || undefined), 2), data = _b[0], setData = _b[1];
    var _c = __read(React.useState(getStoreConfig() || props.data || undefined), 2), storeConf = _c[0], setStoreConf = _c[1];
    React.useEffect(function () {
        function initData() {
            return __awaiter(this, void 0, void 0, function () {
                var isNotFound, data_2, isCMSFooter;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isNotFound = window.location.pathname;
                            if (!!data) return [3 /*break*/, 4];
                            isCMSFooter = getKillSwitchCMS(storeConf);
                            if (!(isCMSFooter === 'OFF')) return [3 /*break*/, 1];
                            return [3 /*break*/, 3];
                        case 1: return [4 /*yield*/, getInitialData()];
                        case 2:
                            data_2 = _a.sent();
                            _a.label = 3;
                        case 3:
                            // setLoading(false)
                            setData(data_2);
                            setStoreConf(storeConf);
                            _a.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        initData();
    }, [data]);
    React.useEffect(function () {
        function storeInitData() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (!storeConf) {
                        setStoreConf(storeConf);
                    }
                    return [2 /*return*/];
                });
            });
        }
        storeInitData();
    }, [storeConf]);
    return (React.createElement(FooterContext.Provider, { value: { data: data, storeConf: storeConf, loading: loading } },
        React.createElement(React.Fragment, null,
            React.createElement("div", { id: "footer-data", dangerouslySetInnerHTML: {
                    __html: "<script>\n        window.initialFooterData=" + serialize(props.data) + "\n        </script>"
                } }),
            children)));
}
